<script>
/**
 * @overview 游戏管理 - 列表单项
 *
 * @author huojinzhao
 */

export default {
  name: "GameListItem",

  props: {
    data: {
      type: Object,
      required: true,
    },
    type: {
      type: [Number, String],
      default: null,
    },
    isJinyong: {
      type: Boolean,
      default: false,
    },
    // 复制权限
    isFuzhiPermissions: {
      type: Boolean,
      default: false,
    },
    // 移动权限
    isMovePermissions: {
      type: Boolean,
      default: false,
    },
    grandpa: {
      type: [Number, String],
      default: null,
    },
  },
  computed: {
    // 如果预览地址不存在则,则不让预览
    typeData() {
      let type = 'edit,preview,fuzhi,move,delete';
      // 课中的时候不需要复制 - 兼容旧数据
      if (`${this.type}` === '30') {
        type = 'edit,preview,move,delete';
      }

      if (this.data.form_type >= 0 && this.data.url === null) {
        type = 'edit,fuzhi,move,delete';

        // 课中的时候不需要复制
        if (`${this.data.type}` === '30') {
          type = 'edit,move,delete';
        }
      }
      if (`${this.grandpa}` === '2') {
        type = 'edit,fuzhi,move,delete';
      }
      if (this.isJinyong) {
        type += ',jinyong';
      }
      return type;
    },
  },
};
</script>

<template>
  <AppMasker
    :is-fuzhi-permissions="isFuzhiPermissions"
    :is-move-permissions="isMovePermissions"
    :types="typeData"
    :is-jinyong="isJinyong && `${data.enabled_status}` === '1'"
    class="game-list-item"
    radius
    @edit="$emit('update', data.id)"
    @delete="$emit('delete', data.id)"
    @fuzhi="$emit('fuzhi', data)"
    @move="$emit('move', data)"
    @jinyong="$emit('jinyong', data, type)"
    @preview="$emit('preview', data.id,data.game_pack_url, data.game_question_type)"
  >
    <p
      v-if="data.image || data.cover_image_url || data.game_pack_image"
      :style="`background-image:url('${data.image || data.cover_image_url || data.game_pack_image}')`"
      class="bg"/>
    <i
      :class="{'is-image':data.image || data.cover_image_url || data.game_pack_image}"
      class="iconfont icon-game" />
    <p
      v-if="isJinyong"
      class="is-jin-yong"
    ><el-switch
      :value="isJinyong && `${data.enabled_status}` === '1'"
      active-color="#13ce66" /></p>
    <div
      v-show="type !== 30 && type !== 666"
      class="game_type">{{ data.game_pack_name }}</div>

    <ol class="module-list-item-label">
      <li class="layout-ellipsis">{{ data.nick_name || data.name }}</li>
      <li class="layout-ellipsis">{{ data.create_date }}</li>
    </ol>

  </AppMasker>
</template>

<style lang="postcss">
.game-list-item .bg{
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
  background-size: contain;
  z-index: -1;
  background-repeat: no-repeat;
}
.game-list-item {
  display: flex;
  flex-direction: column;
}

.game-list-item > i {
  margin: auto;
  font-size: 60px;
  color: var(--font-color-secondary);
}
.game_type{
  position: absolute;
  right: 10px;
  top: 10px;
}
.is-jin-yong{
  position: absolute;
  left: 10px;
  top: -8px;
  z-index: 1;
}
.layout-mask-attendant{
  z-index: 11;
}
.layout-mask-master::before{
  z-index: 10;
}
.icon-game.is-image:before{
  content: '';
}
</style>
